import { getStore as getMailStore } from '../../store/Store';

/**
 *  Returns selected item id from the mail store
 */
export default function getSelectedItemId(): string {
    return getMailStore().mailModule.selectedId;
}
